module.exports = "<div class=\"page-container\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 597
// module chunks = 8